import { render, staticRenderFns } from "./pendingTasks.vue?vue&type=template&id=6a062046&scoped=true&"
import script from "./pendingTasks.vue?vue&type=script&lang=js&"
export * from "./pendingTasks.vue?vue&type=script&lang=js&"
import style0 from "./pendingTasks.vue?vue&type=style&index=0&id=6a062046&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a062046",
  null
  
)

export default component.exports